import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Avatar } from '../avatar/avatar.js';
import { Button } from '../button/button.js';
import { Textarea } from '../textarea/textarea.js';

/**
 * Comment component to be used when a user can write a comment
 */
var Comment = function Comment(_ref) {
  var className = _ref.className,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === undefined ? 'Add a comment...' : _ref$placeholder,
    _ref$postButtonText = _ref.postButtonText,
    postButtonText = _ref$postButtonText === undefined ? 'Send' : _ref$postButtonText,
    _ref$cancelButtonText = _ref.cancelButtonText,
    cancelButtonText = _ref$cancelButtonText === undefined ? 'Cancel' : _ref$cancelButtonText,
    postButtonDisabled = _ref.postButtonDisabled,
    cancelButtonDisabled = _ref.cancelButtonDisabled,
    onPostMessage = _ref.onPostMessage,
    onCancel = _ref.onCancel,
    newLineOnEnter = _ref.newLineOnEnter,
    avatar = _ref.avatar,
    message = _ref.message,
    setMessage = _ref.setMessage,
    Textarea$1 = _ref.Textarea,
    showButtons = _ref.showButtons;
  var classes = classNames('cogs-v10', 'cogs-comment', message && 'cogs-comment--with-message', avatar && 'cogs-comment--with-avatar', showButtons === true && 'cogs-comment--force-buttons-visible', showButtons === false && 'cogs-comment--force-buttons-hidden', (onPostMessage || onCancel) && 'cogs-comment--with-buttons', className);
  var onKeyDown = function onKeyDown(e) {
    if (onPostMessage && e.keyCode === 13 && (!newLineOnEnter && !e.shiftKey || newLineOnEnter && e.shiftKey)) {
      // Prevent a new-line and Send the message
      e.preventDefault();
      if (onPostMessage) {
        onPostMessage(message);
      }
    }
  };
  var onChange = function onChange(e) {
    var target = e.target;
    if (setMessage) {
      setMessage(target.value);
    }
  };
  return jsxs("div", {
    className: classes,
    children: [avatar && jsx(Avatar, {
      text: avatar,
      size: "medium",
      "data-testid": "cogs-comment-avatar"
    }), jsxs("div", {
      className: "cogs-v10 cogs-comment--form",
      children: [Textarea$1 ? jsx("div", {
        className: "cogs-v10 cogs-textarea",
        children: jsx("div", {
          className: "cogs-v10 cogs-textarea--content-editable",
          children: Textarea$1
        })
      }) : jsx(Textarea, {
        placeholder: placeholder,
        value: message,
        resizable: "vertical",
        onChange: onChange,
        onKeyDown: onKeyDown,
        fullWidth: true
      }), (showButtons !== undefined || onPostMessage || onCancel) && jsxs("div", {
        className: "cogs-v10 cogs-comment--buttons",
        "data-testid": "cogs-comment-buttons",
        children: [onCancel && jsx(Button, {
          type: "ghost",
          onClick: onCancel,
          className: "cogs-v10 cogs-comment--cancel-button",
          disabled: cancelButtonDisabled !== undefined ? cancelButtonDisabled : !message,
          children: cancelButtonText
        }), onPostMessage && jsx(Button, {
          type: "primary",
          className: "cogs-v10 cogs-comment--send-button",
          onClick: function onClick() {
            return onPostMessage(message);
          },
          disabled: postButtonDisabled !== undefined ? postButtonDisabled : !message,
          children: postButtonText
        })]
      })]
    })]
  });
};

export { Comment };
